export const CRM_SECTION_ORDER = [
  "button",
  "badge",
  "card",
  "modal",
  "dialog",
  "dropdown",
  "form",
  "input",
  "table",
  "datepicker",
  "paginated-table",
];

export const CRM_SECTION_DESCRIPTIONS: Record<string, string> = {
  button: "Current CRM button surface from Components/ui and its shadcn-backed wrapper layer.",
  badge: "Status and label badges exposed through the shared UI layer.",
  card: "Shared card primitives used across CRM pages and forms.",
  modal: "Shared modal shell and sub-sections from Components/ui/Modal.tsx.",
  dialog: "Shared confirm/warning/error dialog stack using DialogProvider, CommonDialog, and dialogService.",
  dropdown: "Shared dropdown primitives backed by the CRM dropdown wrapper.",
  form: "Shared form shell helpers such as Form, FormGroup, and FormFeedback.",
  input: "Shared text, textarea, select, and checkbox inputs from Components/ui.",
  table: "Shared table primitive exposed by Components/ui.",
  datepicker: "Shared CommonDatePicker wrapper used across CRM filters and forms.",
  "paginated-table": "Current CRM paginated table variants: client-side TableContainer and server-style ServerPaginatedTable.",
};

export const CRM_BUTTON_COLORS = [
  "primary",
  "secondary",
  "success",
  "warning",
  "danger",
  "soft-primary",
];

export const CRM_BADGE_COLORS = [
  "primary",
  "secondary",
  "success",
  "warning",
  "danger",
  "outline-primary",
];

export const CRM_SAMPLE_ROWS = Array.from({ length: 36 }, (_, index) => ({
  id: index + 1,
  title: `Shared UI Row ${index + 1}`,
  owner: index % 2 === 0 ? "Operations" : "Marketing",
  status: index % 3 === 0 ? "Active" : index % 3 === 1 ? "Pending" : "Archived",
  updated_at: `2026-04-${String((index % 28) + 1).padStart(2, "0")}`,
}));

export const CRM_TABLE_COLUMNS = [
  { Header: "ID", accessor: "id" },
  { Header: "Title", accessor: "title" },
  { Header: "Owner", accessor: "owner" },
  { Header: "Status", accessor: "status" },
  { Header: "Updated", accessor: "updated_at" },
];
